import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';

export const postPricingModel = pricingModelInfo => {
  return httpClient
    .post('/admin/pricing-model', pricingModelInfo)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const duplicatePricingModel = pricingModelInfo => {
  return httpClient
    .post('/admin/pricing-model/duplicate', pricingModelInfo)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getAllPricingModel = () => {
  return httpClient
    .get('/admin/pricing-model')
    .then(response => response)
    .catch(error => error.response);
};

export const getAllPricingModelWithPricingTable = () => {
  return httpClient
    .get('/admin/pricing-model-table')
    .then(response => response)
    .catch(error => error.response);
};

export const getPricingModel = id => {
  return httpClient
    .get(`/admin/pricing-model/${id}`)
    .then(response => response)
    .catch(error => error.response);
};

export const updatePricingModel = (id, pricingModelInfo) => {
  return httpClient
    .patch(`/admin/pricing-model/${id}`, pricingModelInfo)
    .then(response => response)
    .catch(error => error.response);
};

export const deletePricingModel = id => {
  return httpClient
    .delete(`/admin/pricing-model/${id}`)
    .then(response => response)
    .catch(error => error.response);
};
